// Customer GPS point for this browser session only (never sent to server for storage).
const KEY = "vb.customerGeo";
const valid = (v, max) => typeof v === "number" && Number.isFinite(v) && Math.abs(v) <= max;

export const setCustomerGeo = (pincode, lat, lng) => {
  if (valid(lat, 90) && valid(lng, 180) && !(lat === 0 && lng === 0)) sessionStorage.setItem(KEY, JSON.stringify({ pincode, lat, lng }));
};
export const clearCustomerGeo = () => sessionStorage.removeItem(KEY);
export const getCustomerGeoFor = (pincode) => {
  try {
    const g = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return g && pincode && g.pincode === pincode && valid(g.lat, 90) && valid(g.lng, 180) ? g : null;
  } catch { return null; }
};
